import React, { useEffect, useState } from 'react';
import { SINAV_DERSLERI } from '../lib/dersler';
import { DersIkon } from './ui/SinavBolumleri';

// LGS DERS SEÇİCİ (2026-10-31, kullanıcı isteği: YKS ders seçicisinin benzeri, "içerik farklı").
// YKS'den farkları:
//  · Bölümler LGS oturumları: Sözel (Türkçe, İnkılap, Din, İngilizce) · Sayısal (Matematik, Fen).
//    Sıra SINAV_DERSLERI.LGS (dersler.js) — tek kaynak.
//  · Tek müfredat (Maarif) ve satış yok: çubuk 2018/Maarif/satılan değil, onaylı / onay bekleyen.
//  · Görünüm "optik form" dili (lgs.* belirteçleri, Lexend); seçili ders optik mürekkebiyle.
// Sayılar GET /api/sorular/lgs-ders-ozeti (süzgeçsiz; kısıtlı kullanıcı yalnız kendi dersleri).
export const LGS_OTURUMLARI = [
  { ad: 'Sözel', dersler: ['lgs_turkce', 'lgs_inkilap', 'lgs_din', 'lgs_ingilizce'] },
  { ad: 'Sayısal', dersler: ['lgs_matematik', 'lgs_fen'] },
];
const ONAY = '#2F7D5B';
const BEKLEYEN = '#B7791F';
const sayi = (n) => Number(n || 0).toLocaleString('tr-TR');

/** Görünür dersleri oturumlara dağıtır; görünür dersi kalmayan oturum düşer. */
export function oturumlaraAyir(gorebilir = () => true) {
  const aileler = SINAV_DERSLERI.LGS || [];
  return LGS_OTURUMLARI.map((o) => ({
    ...o,
    aileler: o.dersler.map((k) => aileler.find((a) => a.key === k)).filter((a) => a && gorebilir(a.key)),
  })).filter((o) => o.aileler.length > 0);
}

function Hucre({ aile, toplam, onayli, secili, onSec }) {
  const bekleyen = Math.max(0, toplam - onayli);
  const pay = (n) => (toplam ? `${(n / toplam) * 100}%` : '0%');
  const etiket = `${aile.label}: ${sayi(toplam)} soru (${sayi(onayli)} onaylı, ${sayi(bekleyen)} onay bekleyen)`;
  return (
    <button type="button" data-lgs-ders={aile.key} aria-pressed={secili} aria-label={etiket} title={etiket}
      onClick={() => onSec(aile.key)}
      className={`relative flex min-w-0 flex-col gap-1 border-l border-t border-lgs-cizgi px-2.5 pb-1.5 pt-1.5 text-left transition-colors
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lgs-optik
        ${secili ? 'bg-lgs-optikacik' : 'bg-white hover:bg-lgs-kagit'}`}>
      <span className="flex min-w-0 items-center gap-1.5">
        <DersIkon dersKey={aile.key} className="h-3.5 w-3.5 shrink-0" style={{ color: aile.renk }} />
        <span className={`min-w-0 flex-1 truncate text-[12px] leading-tight ${secili ? 'font-semibold text-lgs-optik' : 'font-medium text-lgs-murekkep'}`}>
          {aile.label}
        </span>
      </span>
      <span className="flex items-baseline justify-between gap-1.5">
        <span className="text-[15px] font-semibold leading-none tabular-nums text-lgs-murekkep">{sayi(toplam)}</span>
        <span className="flex gap-1 text-[10px] font-medium leading-none tabular-nums">
          <span style={{ color: ONAY }} title="onaylı">{sayi(onayli)}</span>
          {bekleyen > 0 && <><span className="text-[#C9CED6]">·</span><span style={{ color: BEKLEYEN }} title="onay bekleyen">{sayi(bekleyen)}</span></>}
        </span>
      </span>
      <span className="flex h-1 w-full overflow-hidden rounded-full bg-lgs-kagit" aria-hidden="true">
        <span className="h-full" style={{ width: pay(onayli), backgroundColor: ONAY }} />
        <span className="h-full" style={{ width: pay(bekleyen), backgroundColor: BEKLEYEN, opacity: 0.55 }} />
      </span>
      {secili && <span className="absolute inset-x-0 bottom-0 h-0.5 bg-lgs-optik" />}
    </button>
  );
}

/**
 * secili: seçili ders değeri ('' = bütün dersler). onSec(key|''): aynı derse ikinci dokunuş seçimi kaldırır.
 * yenile: değişince sayılar yeniden çekilir (ör. onay sonrası başlık sayacı).
 */
export default function LgsDersSecici({ apiUrl, authFetch, secili = '', onSec, gorebilir, yenile }) {
  const [ozet, setOzet] = useState({ sayilar: {}, onayli: {} });
  useEffect(() => {
    let iptal = false;
    authFetch(`${apiUrl}/api/sorular/lgs-ders-ozeti`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!iptal && d) setOzet({ sayilar: d.sayilar || {}, onayli: d.onayli || {} }); })
      .catch(() => {});
    return () => { iptal = true; };
  }, [apiUrl, authFetch, yenile]);

  const oturumlar = oturumlaraAyir(gorebilir);
  if (!oturumlar.length) return null;
  const tikla = (k) => onSec(k === secili ? '' : k);
  return (
    <div data-testid="lgs-ders-secici" className="mb-3 flex flex-wrap gap-2.5">
      {oturumlar.map((o) => {
        const n = o.aileler.length;
        const toplam = o.aileler.reduce((t, a) => t + (ozet.sayilar[a.key] || 0), 0);
        return (
          <section key={o.ad} className="min-w-0 overflow-hidden rounded-lg border border-lgs-cizgi bg-white"
            style={{ flex: `${n} 1 ${n * 116}px` }}>
            <header className="flex items-baseline justify-between gap-3 border-b border-lgs-cizgi bg-lgs-kagit px-2.5 py-0.5">
              <h3 className="text-[11px] font-semibold uppercase tracking-wide text-lgs-soluk">{o.ad}</h3>
              <span className="text-[11px] font-medium tabular-nums text-lgs-soluk">{sayi(toplam)}</span>
            </header>
            <div className="overflow-hidden">
              <div className="-ml-px -mt-px grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(108px, 1fr))' }}>
                {o.aileler.map((a) => (
                  <Hucre key={a.key} aile={a} toplam={ozet.sayilar[a.key] || 0} onayli={ozet.onayli[a.key] || 0}
                    secili={a.key === secili} onSec={tikla} />
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
